export const START_NEW_GAME = '[Game] start new';
export const GAME_STARTED = '[Game] started';
export const END_GAME = '[Game] end';
